import Vue from "vue";

export default {
  SET_LOADING(state, v) { state.loading = v; },
  SET_CREATING(state, v) { state.creating = v; },
  SET_ITEMS(state, { items, meta }) { state.items = items; state.meta = meta || {}; },
  SET_USERS(state, users) { state.users = users; state.usersLoaded = true; },

  // upsert одной задачи (после create/update/complete/reopen/stop_recurrence)
  UPSERT(state, task) {
    const i = state.items.findIndex((t) => t.id === task.id);
    if (i === -1) state.items.unshift(task);
    else Vue.set(state.items, i, task);
  },
  REMOVE(state, id) {
    state.items = state.items.filter((t) => t.id !== id);
  },

  // Полный сброс модуля при логауте / смене филиала: иначе ленивый кэш
  // users+usersLoaded переживает смену tenant'а → stale-список исполнителей.
  RESET(state) {
    state.items = [];
    state.meta = {};
    state.loading = false;
    state.creating = false;
    state.users = [];
    state.usersLoaded = false;
  },
};
